export const LIMIT_APPLICATION_BOTTLE = 630
export const LIMIT_USER_REDEMPTION = 2
export const START_DATE = '2026-03-31T09:00:00+08:00' 
export const END_DATE = '2026-04-04T19:00:00+08:00'
